import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import KloudOpsGerenteDashboard from './KloudOpsGerenteDashboard';
import KloudOpsAgenteDashboard from './KloudOpsAgenteDashboard';

export default function KloudOpsDashboard() {
  const { hasPermission } = useAuth();
  const { user, permissions } = useAuth();

  console.log('ROLES:', user?.roles);
  console.log('PERMISSIONS:', permissions);

  if (hasPermission('ops.dashboard.management')) {
    return <KloudOpsGerenteDashboard />;
  }

  return <KloudOpsAgenteDashboard />;
}
